import { Injectable } from '@angular/core';

@Injectable()
export class WebStorageService {
  private localStorage: Storage;
  private sessionStorage: Storage;

  constructor() {
    if (!window.localStorage) {
      throw new ReferenceError('Your browser does not support Web Storage');
    }

    this.localStorage = window.localStorage;
    this.sessionStorage = window.sessionStorage;
  }

  setLocalStorage<T = any>(name: string, value: T) {
    if (!name) {
      return;
    }

    this.localStorage.removeItem(name);

    try {
      const serializedValue = JSON.stringify(value);
      this.localStorage.setItem(name, serializedValue);
    } catch {
      console.error('set local storage failed');
    }
  }

  getLocalStorage<T = any>(name: string): T {
    if (!name) {
      return;
    }

    const rawItem = this.localStorage.getItem(name);

    try {
      return JSON.parse(rawItem) as T;
    } catch {
      return (rawItem as unknown) as T;
    }
  }

  removeLocalStorage(name: string) {
    this.localStorage.removeItem(name);
  }

  setSessionStorage<T = any>(name: string, value: T) {
    if (!name) {
      return;
    }

    this.sessionStorage.removeItem(name);

    try {
      const serializedValue = JSON.stringify(value);
      this.sessionStorage.setItem(name, serializedValue);
    } catch {
      console.error('set session storage failed');
    }
  }

  getSessionStorage<T = any>(name: string): T {
    if (!name) {
      return;
    }

    const rawItem = this.sessionStorage.getItem(name);
    try {
      return JSON.parse(rawItem) as T;
    } catch {
      return (rawItem as unknown) as T;
    }
  }

  removeSessionStorage(name: string) {
    this.sessionStorage.removeItem(name);
  }
}
